export default __webpack_public_path__ + "static/media/line_to_heart.34272c57.png";